import styled from "styled-components";

export const RuleText = styled.span`
  font-weight: 400;
  font-size: 14px;
  color: var(--main-color);
  cursor: pointer;
`;
export const MemberSystemModalRules = styled.div`
  padding: 30px 16px 0 24px;
  p {
    color: #e0e1e1;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    padding-bottom: 4px;
  }
`;
